export default __webpack_public_path__ + "static/media/vertical-line.7c68c6af.svg";